import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import App from './App.jsx';

import './styles/tokens.css';
import './styles/app.css';

// Theme is a local preference; the design ships a dark primary and a light
// pass with identical structure.
const stored = localStorage.getItem('superchat:theme');
document.documentElement.setAttribute('data-theme', stored ?? 'dark');

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Outermost boundary: catches a failure in the router, the auth provider
        or the shell itself — everything the per-route boundary sits inside. */}
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
